import "./index.css";
import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

interface TypeRuleWarningProps {
  /**
   * @param warning 是否开启警告提示
   * @description true 显示警告图标、border 变更为黄色
   */
  warning?: boolean;
  children?: React.ReactNode;
}

/**
 * @name RuleWarning Form value 校验 提示
 * @description 对 非规范Form组件，增加 warning style 警告提示
 */
const RuleWarning: React.FC<TypeRuleWarningProps> = ({ warning, children }) => (
  <div className={warning ? "escrow-form-warning" : ""}>
    {children}
    {warning ? <InfoCircleOutlined rev={undefined} /> : null}
  </div>
);

export default RuleWarning;
